import React, { useState } from "react";
import { Space, Select, DatePicker } from "antd";
import Button from '@mui/material/Button';
import moment from "moment";

const { RangePicker } = DatePicker;


const FiltersHeader = (props) => {
	const [availableGroups, setAvailableGroups] = useState(props.accountGroupingFilter); // original group list

	const addGroupFilter = () => {
		if (availableGroups.length > 0) {
			props.setGroupingFilters(prev => [
				...prev,
				{ logicOperator: "AND", grouping: null, group: [] }
			]);
		}
	};

	const updateGroupFilter = (index, key, value) => {
		const updated = [...props.groupingFilters];
		updated[index][key] = value;

		if (key === "grouping") {
			props.handleAccountGroupingChange(value); // only needed for 'grouping' key
			updated[index].group = [];
		}

		props.setGroupingFilters(updated);
	};

	const clearFilters = () => {
		props.setGroupingFilters([]);
		props.clearFilters(); // Clear parent filters too
	};

	return (

		<Space style={{ width: "100%", display: 'flex', flexWrap: 'wrap' }}>
			<RangePicker
				placeholder={["Start Date", "End Date"]}
				value={props.dateRangeFilter}
				style={{ width: "100%" }}
				onCalendarChange={props.handleDateFilter}
				disabledDate={(current) => {
					return moment().add(0, "days") < current;
				}}
				disabled={props.disableDatePicker}
			/>

			{/* Dynamic Grouping Filters */}
			{props?.groupingFilters?.map((filter, idx) => (
				<React.Fragment key={idx}>
					{idx > 0 &&
					<Select
						style={{ width: 80 }}
						value={filter.logicOperator}
						onChange={(val) => updateGroupFilter(idx, 'logicOperator', val)}
					>
						<Select.Option value="AND">AND</Select.Option>
						<Select.Option value="OR">OR</Select.Option>
					</Select>}
					<Select
						style={{ width: 250 }}
						placeholder="Select Account Grouping"
						value={filter.grouping}
						onChange={(val) => {
							updateGroupFilter(idx, 'grouping', val)
						}}
					>
						{props.accountGroupingFilter.map(item => (
							<Select.Option key={item} value={item}>{item}</Select.Option>
						))}
					</Select>
					<Select
						style={{ width: 250 }}
						mode="multiple"
						placeholder="Select Group"
						value={filter.group}
						onChange={(val) => updateGroupFilter(idx, 'group', val)}
						disabled={
							!filter.grouping || 
							props.loadingGroupingOptions?.[props.transactionGroupingToApiMapping?.[filter.grouping]]
						}
					>
						{[...props.selectGroupFilter]
							.sort((a, b) => a.name.localeCompare(b.name))
							.map(item => (
								<Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
							))}
					</Select>
				</React.Fragment>
			))}

			{/* Add More Filters */}
			{availableGroups.length > props?.groupingFilters?.length && (
				<Button size="medium" onClick={addGroupFilter} sx={{ fontSize: 14 }}>+Grouping Filter</Button>
			)}
			<Button disableElevation fullWidth size="small" variant="contained" color="primary" sx={{ fontSize: 14, width: '100%', textTransform: 'none' }} onClick={props.applyFilters}>Apply</Button>
			<Button disableElevation fullWidth size="small" variant="outlined" color="secondary" sx={{ fontSize: 14, width: '100%', textTransform: 'none' }} onClick={clearFilters}>Clear</Button>
		</Space>
	);
};

export default FiltersHeader;
